module.exports = __webpack_public_path__ + "static/media/smartbilling.89cf72b0.svg";